import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

// organism — DWR sheet section: sezione titolata della scheda PG.
// Pattern .sheet-section mockup (styles.css righe 1786-1796): h2 Cinzel
// uppercase con border-bottom 2px ink + body slot flex-column.
// Livello organism (non molecule) perché ospita logica conditional (es.
// Incantesimi caster-only) e in PR future ospiterà azioni (modifica equipment).

interface SheetSectionProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export function SheetSection({ title, children, className }: SheetSectionProps) {
  return (
    <section className={cn('flex flex-col gap-[0.6rem]', className)}>
      <h2 className="font-display border-ink m-0 border-b-2 pb-[0.3rem] text-base font-bold tracking-[0.1em] uppercase">
        {title}
      </h2>
      <div className="flex flex-col gap-[0.4rem]">{children}</div>
    </section>
  );
}
